
export const formatDocumentTitle = (title: string): string => {
  return title
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getDocumentDisplayTitle = (type: string): string => {
  const titleMap: Record<string, string> = {
    'pitch_deck': 'Pitch Deck',
    'strategic_plan': 'Strategic Plan',
    'business_model_canvas': 'Business Model Canvas',
    'swot_analysis': 'SWOT Analysis',
    'okr': 'OKR',
    'market_research': 'Market Research',
    'innovation_roadmap': 'Innovation Roadmap',
    'sop': 'Standard Operating Procedures',
    'customer_acquisition_plan': 'Customer Acquisition Plan',
    'kpi_creation': 'KPI Creation',
    'business_plan': 'Business Plan',
    'go_to_market_strategy': 'Go-To-Market Strategy',
    'financial_forecast': 'Financial Forecast',
    'budget_template': 'Budget Template',
    'cash_flow_statement': 'Cash Flow Statement',
    'income_statement': 'Income Statement',
    'balance_sheet': 'Balance Sheet',
    'financial_dashboard': 'Financial Dashboard',
    'tech_architecture': 'Technology Architecture',
    'cybersecurity_policy': 'Cybersecurity Policy',
    'digital_transformation_plan': 'Digital Transformation Plan',
    'process_optimization': 'Process Optimization',
    'quality_management': 'Quality Management',
    'operations_manual': 'Operations Manual',
    'product_roadmap': 'Product Roadmap',
    'user_research_plan': 'User Research Plan',
    'product_requirements': 'Product Requirements'
  };
  
  return titleMap[type] || formatDocumentTitle(type);
};

// New function to format suggestion titles without underscores
export const formatSuggestionTitle = (title: string): string => {
  // Handle specific cases that should be formatted nicely
  const specialCases: Record<string, string> = {
    'swot_analysis': 'SWOT Analysis',
    'go_to_market_strategy': 'Go-to-Market Strategy',
    'customer_acquisition_plan': 'Customer Acquisition Plan',
    'kpi_creation': 'KPI Creation',
    'okr': 'OKR Creation',
    'sop': 'Standard Operating Procedures',
    'tech_architecture': 'Technology Architecture',
    'digital_transformation_plan': 'Digital Transformation Plan',
    'user_research_plan': 'User Research Plan',
    'product_requirements': 'Product Requirements Document'
  };

  // Check if it's a special case first
  if (specialCases[title.toLowerCase()]) {
    return specialCases[title.toLowerCase()];
  }

  // Default formatting - replace underscores with spaces and capitalize
  return title
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
